import { Component } from '@angular/core';
import { GridEnabledDashboardComponent } from './grid-enabled-dashboard';

@Component({
  standalone: false,
  selector: 'mtn-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends GridEnabledDashboardComponent {

  constructor() {
    super();
  }

}
